export const response_sucursal_find = {
  description: 'Sucursal encontrada',
  schema: {
    type: 'object',
    properties: {
      message: { type: 'string' },
      data: {
        type: 'object',
        properties: {
          id: { type: 'string' },
          empresa_id: { type: 'string' },
          punto_establecimiento: { type: 'string' },
          descripcion: { type: 'string' },
          direccion: { type: 'string' },
          numero_casa: { type: 'string' },
          pais_id: { type: 'string' },
          departamento_id: { type: 'string' },
          distrito_id: { type: 'string' },
          ciudad_id: { type: 'string' },
          barrio_id: { type: ['string', 'null'] },
          telefono: { type: 'string' },
          email: { type: 'string' },
          complemento_1: { type: 'string' },
          complemento_2: { type: 'string' },
          active: { type: 'boolean' },
          created_at: { type: 'string', format: 'date-time' },
          updated_at: { type: 'string', format: 'date-time' },
          usuario: { type: 'string' },
        },
      },
    },
  },
};
export const body_create_sucursal = {
  type: 'object',
  properties: {
    empresa_id: { type: 'string' },
    punto_establecimiento: { type: 'string' },
    descripcion: { type: 'string' },
    direccion: { type: 'string' },
    numero_casa: { type: 'string' },
    pais_id: { type: 'string' },
    departamento_id: { type: 'string' },
    distrito_id: { type: 'string' },
    ciudad_id: { type: 'string' },
    barrio_id: { type: ['string', 'null'] },
    telefono: { type: 'string' },
    email: { type: 'string' },
    complemento_1: { type: 'string' },
    complemento_2: { type: 'string' },
    usuario: { type: 'string' },
  },
};
export const response_create_sucursal = {
  description: 'Sucursal creada',
  schema: {
    type: 'object',
    properties: {
      message: { type: 'string' },
      data: {
        type: 'object',
        properties: {
          id: { type: 'string' },
          empresa_id: { type: 'string' },
          punto_establecimiento: { type: 'string' },
          descripcion: { type: 'string' },
          direccion: { type: 'string' },
          numero_casa: { type: 'string' },
          pais_id: { type: 'string' },
          departamento_id: { type: 'string' },
          distrito_id: { type: 'string' },
          ciudad_id: { type: 'string' },
          barrio_id: { type: ['string', 'null'] },
          telefono: { type: 'string' },
          email: { type: 'string' },
          complemento_1: { type: 'string' },
          complemento_2: { type: 'string' },
          active: { type: 'boolean' },
          created_at: { type: 'string', format: 'date-time' },
          updated_at: { type: 'string', format: 'date-time' },
          usuario: { type: 'string' },
        },
      },
    },
  },
};

export const response_sucursal_all = {
  description: 'Sucursales obtenidas exitosamente',
  schema: {
    type: 'object',
    properties: {
      message: { type: 'string' },
      data: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            id: { type: 'string' },
            empresa_id: { type: 'string' },
            punto_establecimiento: { type: 'string' },
            descripcion: { type: 'string' },
            direccion: { type: 'string' },
            numero_casa: { type: 'string' },
            pais_id: { type: 'string' },
            departamento_id: { type: 'string' },
            distrito_id: { type: 'string' },
            ciudad_id: { type: 'string' },
            barrio_id: { type: ['string', 'null'] },
            telefono: { type: 'string' },
            email: { type: 'string' },
            complemento_1: { type: 'string' },
            complemento_2: { type: 'string' },
            active: { type: 'boolean' },
            created_at: { type: 'string', format: 'date-time' },
            updated_at: { type: 'string', format: 'date-time' },
            usuario: { type: 'string' },
          },
        },
      },
      total: { type: 'number' },
      page: { type: 'number' },
      limit: { type: 'number' },
      lastPage: { type: 'number' },
    },
  },
};
export const response_update_sucursal = {};
export const response_delete_sucursal = {};
